// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Xt8OulBkWrhO2IPfoNu3 {
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 20px 0;
}
.Xt8OulBkWrhO2IPfoNu3 .cWT4LAXXmSJHEKrciFx0 {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid rgba(237, 235, 239, 0.1);
}
.Xt8OulBkWrhO2IPfoNu3 .cWT4LAXXmSJHEKrciFx0 .lr2512iVy9FEZVRJMvGd {
  font-size: 14px;
  font-weight: 600;
  color: #7d7d7d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
}
.Xt8OulBkWrhO2IPfoNu3 .cWT4LAXXmSJHEKrciFx0 .zrVgJOpBttDpq7etszzY {
  display: flex;
  gap: 12px;
}
.Xt8OulBkWrhO2IPfoNu3 .cWT4LAXXmSJHEKrciFx0 .zrVgJOpBttDpq7etszzY .w6ieIwLv9FHi4qCqx1QD {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #2d2d2d;
  border: 1px solid #8d56e8;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #b6b6b6;
  transition: all 0.2s;
}
.Xt8OulBkWrhO2IPfoNu3 .cWT4LAXXmSJHEKrciFx0 .zrVgJOpBttDpq7etszzY .w6ieIwLv9FHi4qCqx1QD .FMuEpC1cU2ByF_2kWM0p {
  font-size: 18px;
}
.Xt8OulBkWrhO2IPfoNu3 .cWT4LAXXmSJHEKrciFx0 .zrVgJOpBttDpq7etszzY .w6ieIwLv9FHi4qCqx1QD:hover {
  background-color: #6439df;
  border-color: #6439ab;
}
.Xt8OulBkWrhO2IPfoNu3 .cWT4LAXXmSJHEKrciFx0 .zrVgJOpBttDpq7etszzY .w6ieIwLv9FHi4qCqx1QD:active {
  background-color: #5b37c0;
}
.Xt8OulBkWrhO2IPfoNu3 .aNFuGCmbhqV75qF_JTNu .lr2512iVy9FEZVRJMvGd {
  font-size: 14px;
  font-weight: 600;
  color: #7d7d7d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 16px;
}
.Xt8OulBkWrhO2IPfoNu3 .aNFuGCmbhqV75qF_JTNu .FUe8xkDTVa4ahNTjDm6V {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}
@media (max-width: 600px) {
  .Xt8OulBkWrhO2IPfoNu3 .aNFuGCmbhqV75qF_JTNu .FUe8xkDTVa4ahNTjDm6V {
    grid-template-columns: 1fr;
  }
}
.Xt8OulBkWrhO2IPfoNu3 .aNFuGCmbhqV75qF_JTNu .FUe8xkDTVa4ahNTjDm6V .WfggMusdlhWZqH0QjDXR {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: #2d2d2d;
  border: 1px solid rgba(237, 235, 239, 0.1);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  min-height: 70px;
}
.Xt8OulBkWrhO2IPfoNu3 .aNFuGCmbhqV75qF_JTNu .FUe8xkDTVa4ahNTjDm6V .WfggMusdlhWZqH0QjDXR .y47_Qy41qm4o7QZLTNDk {
  font-size: 32px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.Xt8OulBkWrhO2IPfoNu3 .aNFuGCmbhqV75qF_JTNu .FUe8xkDTVa4ahNTjDm6V .WfggMusdlhWZqH0QjDXR .zejx7_tR2JHeoaTOWcMg {
  flex: 1;
  min-width: 0;
}
.Xt8OulBkWrhO2IPfoNu3 .aNFuGCmbhqV75qF_JTNu .FUe8xkDTVa4ahNTjDm6V .WfggMusdlhWZqH0QjDXR .zejx7_tR2JHeoaTOWcMg .FsTqNg6QW_4l9gQAbAMg {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}
.Xt8OulBkWrhO2IPfoNu3 .aNFuGCmbhqV75qF_JTNu .FUe8xkDTVa4ahNTjDm6V .WfggMusdlhWZqH0QjDXR .zejx7_tR2JHeoaTOWcMg .XfROYuFxTdwk4Md37mmQ {
  font-size: 15px;
  font-weight: 600;
  color: #b6b6b6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.Xt8OulBkWrhO2IPfoNu3 .aNFuGCmbhqV75qF_JTNu .FUe8xkDTVa4ahNTjDm6V .WfggMusdlhWZqH0QjDXR .zejx7_tR2JHeoaTOWcMg .hKnWDQAMoAmRvxwkk8az {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  padding: 4px 6px;
  border-radius: 8px;
  white-space: nowrap;
  flex-shrink: 0;
  line-height: 1;
  height: fit-content;
}
.Xt8OulBkWrhO2IPfoNu3 .aNFuGCmbhqV75qF_JTNu .FUe8xkDTVa4ahNTjDm6V .WfggMusdlhWZqH0QjDXR .zejx7_tR2JHeoaTOWcMg .j9T58V7IOOSPeu8lfHdg {
  font-size: 13px;
  color: #636363;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.Xt8OulBkWrhO2IPfoNu3 .aNFuGCmbhqV75qF_JTNu .FUe8xkDTVa4ahNTjDm6V .WfggMusdlhWZqH0QjDXR:hover {
  background-color: #6439df;
  border-color: #6439ab;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(123, 70, 246, 0.15);
}
.Xt8OulBkWrhO2IPfoNu3 .aNFuGCmbhqV75qF_JTNu .FUe8xkDTVa4ahNTjDm6V .WfggMusdlhWZqH0QjDXR:hover .XfROYuFxTdwk4Md37mmQ {
  color: white;
}
.Xt8OulBkWrhO2IPfoNu3 .aNFuGCmbhqV75qF_JTNu .FUe8xkDTVa4ahNTjDm6V .WfggMusdlhWZqH0QjDXR:hover .j9T58V7IOOSPeu8lfHdg {
  color: #b6b6b6;
}
.Xt8OulBkWrhO2IPfoNu3 .aNFuGCmbhqV75qF_JTNu .FUe8xkDTVa4ahNTjDm6V .WfggMusdlhWZqH0QjDXR:active {
  background-color: #5b37c0;
  transform: translateY(0);
}
.Xt8OulBkWrhO2IPfoNu3 .N4vhJKpfvvhRabItZIaT {
  display: flex;
  flex-direction: column;
  width: 189px;
  border-radius: 8px;
  border: 1px solid #8d56e8;
  position: absolute;
  height: 70px;
  width: 190px;
  background-color: #2d2d2d;
  padding: 6px 0px;
  top: 140px;
  right: -75px;
  z-index: 10;
}
.Xt8OulBkWrhO2IPfoNu3 .N4vhJKpfvvhRabItZIaT .xJeOXJ6YoFxZalmhKE8B {
  font-size: 16px;
  padding: 8px 8px 8px 20px;
}
.Xt8OulBkWrhO2IPfoNu3 .N4vhJKpfvvhRabItZIaT .xJeOXJ6YoFxZalmhKE8B:hover {
  background-color: #262626;
  transition: all 0.3s;
}
.Xt8OulBkWrhO2IPfoNu3 .N4vhJKpfvvhRabItZIaT .xJeOXJ6YoFxZalmhKE8B:active {
  background-color: #1e1e1e;
  color: #b6b6b6;
  transition: all 0.3s;
}
.Xt8OulBkWrhO2IPfoNu3 .N4vhJKpfvvhRabItZIaT .xJeOXJ6YoFxZalmhKE8B:disabled {
  background-color: rgba(50, 50, 50, 0.6);
  color: #636363;
  transition: all 0.3s;
}
.Xt8OulBkWrhO2IPfoNu3 .CBpEHYXHt892nsVQC6XS {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Xt8OulBkWrhO2IPfoNu3 .CBpEHYXHt892nsVQC6XS .PXN4RM3lWppp5vyZ1rWH {
  width: 20px;
  padding: 0px;
  background: none;
  border-radius: 0;
}
.Xt8OulBkWrhO2IPfoNu3 .CBpEHYXHt892nsVQC6XS .BwkT1UZbJi1wwRYq0Tth {
  display: flex;
  align-items: center;
  column-gap: 8px;
}
.Xt8OulBkWrhO2IPfoNu3 .RKvRylQVC0o0IVfq1L_y {
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 8px;
}
.Xt8OulBkWrhO2IPfoNu3 .RKvRylQVC0o0IVfq1L_y .KKmiSJYIVDBxpmSTnNqo {
  width: 100%;
  border-radius: 10px;
}
.Xt8OulBkWrhO2IPfoNu3 .gbh7QTAa4GBrMFQzH50v {
  font-size: 16px !important;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 12px;
  width: 100%;
}
.Xt8OulBkWrhO2IPfoNu3 .ZWTNFRMpawqPZKV7zFAB {
  font-size: 16px !important;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 12px;
}
.Xt8OulBkWrhO2IPfoNu3 ._TSf3E1Cq22nZETNbKqw {
  margin-top: 4px;
  color: rgb(116, 116, 116);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/editor/components/modals/NewModal/NewModal.module.scss","webpack://./src/editor/style/variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AAAF;AAEE;EACE,gBAAA;EACA,iBAAA;EACA,8CAAA;AAAJ;AAEI;EACE,eAAA;EACA,gBAAA;EACA,cCqBK;EDpBL,yBAAA;EACA,qBAAA;EACA,mBAAA;AAAN;AAGI;EACE,aAAA;EACA,SAAA;AADN;AAGM;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBCqBO;EDpBP,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,cCdQ;EDeR,oBAAA;AADR;AAGQ;EACE,eAAA;AADV;AAIQ;EACE,yBCxCG;EDyCH,qBCrCG;ADmCb;AAKQ;EACE,yBC5CG;ADyCb;AAUI;EACE,eAAA;EACA,gBAAA;EACA,cCvBK;EDwBL,yBAAA;EACA,qBAAA;EACA,mBAAA;AARN;AAWI;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AATN;AAWM;EALF;IAMI,0BAAA;EARN;AACF;AAUM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,mBC3BO;ED4BP,0CAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;AARR;AAUQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AARV;AAWQ;EACE,OAAA;EACA,YAAA;AATV;AAWU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AATZ;AAYU;EACE,eAAA;EACA,gBAAA;EACA,cCxFI;EDyFJ,mBAAA;EACA,gBAAA;EACA,uBAAA;AAVZ;AAaU;EACE,6DAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;AAXZ;AAcU;EACE,eAAA;EACA,cCjGD;EDkGC,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAZZ;AAgBQ;EACE,yBC1IG;ED2IH,qBCvIG;EDwIH,2BAAA;EACA,+CAAA;AAdV;AAgBU;EACE,YAAA;AAdZ;AAiBU;EACE,cClII;ADmHhB;AAmBQ;EACE,yBCxJG;EDyJH,wBAAA;AAjBV;AAuBE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,yBCzHW;ED0HX,gBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AArBJ;AAuBI;EACE,eAAA;EACA,yBAAA;AArBN;AAuBM;EACE,yBC5II;ED6IJ,oBAAA;AArBR;AAwBM;EACE,yBC9II;ED+IJ,cCxKQ;EDyKR,oBAAA;AAtBR;AAyBM;EACE,uCAAA;EACA,cCjKG;EDkKH,oBAAA;AAvBR;AA4BE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AA1BJ;AA4BI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AA1BN;AA6BI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AA3BN;AA+BE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AA7BJ;AA+BI;EACE,WAAA;EACA,mBAAA;AA7BN;AAiCE;EACE,0BAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AA/BJ;AAkCE;EACE,0BAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAhCJ;AAmCE;EACE,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAjCJ","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Xt8OulBkWrhO2IPfoNu3`,
	"onboardingSection": `cWT4LAXXmSJHEKrciFx0`,
	"sectionTitle": `lr2512iVy9FEZVRJMvGd`,
	"onboardingOptions": `zrVgJOpBttDpq7etszzY`,
	"onboardingButton": `w6ieIwLv9FHi4qCqx1QD`,
	"icon": `FMuEpC1cU2ByF_2kWM0p`,
	"templatesSection": `aNFuGCmbhqV75qF_JTNu`,
	"cardsGrid": `FUe8xkDTVa4ahNTjDm6V`,
	"templateCard": `WfggMusdlhWZqH0QjDXR`,
	"cardIcon": `y47_Qy41qm4o7QZLTNDk`,
	"cardContent": `zejx7_tR2JHeoaTOWcMg`,
	"cardTitleRow": `FsTqNg6QW_4l9gQAbAMg`,
	"cardTitle": `XfROYuFxTdwk4Md37mmQ`,
	"newPill": `hKnWDQAMoAmRvxwkk8az`,
	"cardDescription": `j9T58V7IOOSPeu8lfHdg`,
	"menuBlock": `N4vhJKpfvvhRabItZIaT`,
	"menuItem": `xJeOXJ6YoFxZalmhKE8B`,
	"userBlock": `CBpEHYXHt892nsVQC6XS`,
	"dropdown": `PXN4RM3lWppp5vyZ1rWH`,
	"userName": `BwkT1UZbJi1wwRYq0Tth`,
	"editButtons": `RKvRylQVC0o0IVfq1L_y`,
	"editButton": `KKmiSJYIVDBxpmSTnNqo`,
	"editInput": `gbh7QTAa4GBrMFQzH50v`,
	"title": `ZWTNFRMpawqPZKV7zFAB`,
	"date": `_TSf3E1Cq22nZETNbKqw`
};
export default ___CSS_LOADER_EXPORT___;
